export default "//file.bilionpass.com/japandx-web/0.0.1/static/icon_discount_car.85cb3c1c-e00c97.svg";